export default {
  assets: [],
}
